export default "__VITE_ASSET__CxWhxI26__"